import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=35ea495f&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=35ea495f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea495f",
  null
  
)

export default component.exports